import {toLower} from '@servicenow/ui-utils';

export default function getHostInfo(host) {
	return {
		tagName: toLower(host.tagName),
		componentId: host.getAttribute('component-id')
	};
}
